"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _router = require("next/router");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Search = _interopRequireWildcard(require("@commerce-ui/core2/Search"));
var _Layer = _interopRequireDefault(require("@commerce-ui/core2/Layer"));
var _useQuickSearch = _interopRequireDefault(require("@deosite/api/hooks/REST/useQuickSearch"));
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _ProductRow = _interopRequireDefault(require("../ProductRow"));
var _getDefaultProductImage = require("@deosite/helpers/getDefaultProductImage");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconSearch = function IconSearch(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.438a7.9 7.9 0 1 0 0 15.8 7.9 7.9 0 0 0 0-15.8zm-9.1 7.9a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 16.7l5.503 5.502-.848.849-5.503-5.503.849-.848z"
  }));
};
IconSearch.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  dropDownStyles: {
    height: 424,
    width: 890,
    top: "auto",
    left: "auto"
  }
};
var SearchDesktop = function SearchDesktop(props) {
  var inputSecondary = props.inputSecondary,
    _props$dropDownStyles = props.dropDownStyles,
    dropDownStyles = _props$dropDownStyles === void 0 ? defaultProps.dropDownStyles : _props$dropDownStyles;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var router = (0, _router.useRouter)();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var hitEnter = (0, _react.useRef)(false);
  var _useSearch = (0, _useQuickSearch["default"])(language),
    _useSearch$state = _useSearch.state,
    state = _useSearch$state === void 0 ? {} : _useSearch$state,
    setPhrase = _useSearch.setPhrase,
    phrase = _useSearch.phrase;
  var _state$data = state.data,
    data = _state$data === void 0 ? [] : _state$data,
    _state$isLoading = state.isLoading,
    isLoading = _state$isLoading === void 0 ? false : _state$isLoading;
  var _data$results = data.results,
    results = _data$results === void 0 ? [] : _data$results,
    _data$totalCount = data.totalCount,
    totalCount = _data$totalCount === void 0 ? null : _data$totalCount,
    _data$categories = data.categories,
    categories = _data$categories === void 0 ? [] : _data$categories;
  var translations = {
    search: (0, _langLibrary["default"])("Search"),
    seeAllSuggestions: (0, _langLibrary["default"])("See all suggestions ({{resultsLength}})", {
      resultsLength: totalCount ? totalCount : 0
    })
  };
  var searchController = (0, _Search.useSearch)({
    onChange: function onChange(val) {
      return setPhrase(val);
    },
    onSubmit: function onSubmit(val) {
      if (phrase !== val) {
        hitEnter.current = true;
      } else if ((results === null || results === void 0 ? void 0 : results.length) === 1) {
        router.push("/[...categoryOrProductPage]", "/".concat(results[0].url));
      } else {
        router.push("/catalogsearch/result/[...query]", "/catalogsearch/result/".concat(val));
      }
    }
  });
  (0, _react.useEffect)(function () {
    if (!isLoading && hitEnter.current) {
      hitEnter.current = false;
      if ((results === null || results === void 0 ? void 0 : results.length) === 1) {
        router.push("/[...categoryOrProductPage]", "/".concat(results[0].url));
      } else {
        router.push("/catalogsearch/result/[...query]", "/catalogsearch/result/".concat(phrase));
      }
    }
  }, [isLoading]);
  (0, _react.useEffect)(function () {
    if ((phrase === null || phrase === void 0 ? void 0 : phrase.length) > 0 && !router.asPath.includes("/catalogsearch/result/")) {
      searchController.clear();
    }
  }, [router.asPath]);
  var searchInput = /*#__PURE__*/_react["default"].cloneElement(inputSecondary, {
    placeholder: translations.search,
    leftEnhancer: __jsx(IconSearch, null),
    clearable: true,
    "data-test": "search-desktop"
  });
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Search["default"], {
    input: searchInput,
    layer: __jsx(_Layer["default"], {
      root: {
        boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
        bg: "white",
        overflowY: "auto",
        display: "flex",
        top: dropDownStyles.top,
        left: dropDownStyles.left,
        borderRadius: dropDownStyles.roundness
      },
      width: dropDownStyles.width,
      height: dropDownStyles.height
    }),
    controller: searchController
  }, results && results.length > 0 && function (_ref) {
    var _dropDownStyles$leftC, _dropDownStyles$exten, _dropDownStyles$exten2, _dropDownStyles$exten3, _dropDownStyles$exten4, _dropDownStyles$exten9, _dropDownStyles$exten0, _dropDownStyles$exten1, _dropDownStyles$exten10;
    var close = _ref.close;
    return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
      sx: {
        pt: "s9",
        display: "flex",
        flexDirection: "row"
      }
    }, __jsx(_Box["default"], {
      sx: {
        width: (_dropDownStyles$leftC = dropDownStyles.leftColumnWidth) !== null && _dropDownStyles$leftC !== void 0 ? _dropDownStyles$leftC : "240px",
        ml: "s9",
        pr: "s8",
        color: (_dropDownStyles$exten = (_dropDownStyles$exten2 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten2 === void 0 ? void 0 : _dropDownStyles$exten2.categoryColor) !== null && _dropDownStyles$exten !== void 0 ? _dropDownStyles$exten : "main",
        font: (_dropDownStyles$exten3 = (_dropDownStyles$exten4 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten4 === void 0 ? void 0 : _dropDownStyles$exten4.categoryFont) !== null && _dropDownStyles$exten3 !== void 0 ? _dropDownStyles$exten3 : "base_sans_regular_discount",
        textDecoration: "none"
      }
    }, categories.slice(0, 8).map(function (item) {
      return item.url && __jsx(Link, {
        route: "category-page",
        params: item
      }, __jsx(_LinkRaw["default"], {
        sx: {
          ":hover": {
            bg: "neutral100"
          },
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: "1",
          overflow: "hidden",
          py: "s4"
        },
        title: item.name
      }, item.name));
    })), __jsx(_Box["default"], {
      sx: {
        width: "277px",
        height: "80px"
      }
    }, (results === null || results === void 0 ? void 0 : results.length) > 0 && results.slice(0, dropDownStyles.leftColumnWidth ? 4 : 3).map(function (item) {
      var _dropDownStyles$exten5, _dropDownStyles$exten6, _dropDownStyles$exten7, _dropDownStyles$exten8;
      return __jsx(_Box["default"], {
        sx: {
          height: "80px",
          mb: "s8"
        }
      }, __jsx(_ProductRow["default"], {
        product: item,
        otherDefaultImage: (0, _getDefaultProductImage.getDefaultCategoryProductImage)(global.__appConfig__.searchDefaultImage, language === null || language === void 0 ? void 0 : language.language, item),
        quantity: 1,
        isQuantityPickerEnabled: false,
        onLinkClick: function onLinkClick() {
          return close();
        },
        skuDisabled: dropDownStyles.customColumns !== undefined,
        roundness: dropDownStyles.roundness,
        extendedStyles: dropDownStyles.extendedStyles ? {
          collectionFont: (_dropDownStyles$exten5 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten5 === void 0 ? void 0 : _dropDownStyles$exten5.productCollectionFont,
          productFont: (_dropDownStyles$exten6 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten6 === void 0 ? void 0 : _dropDownStyles$exten6.productNameFont,
          productFontColor: (_dropDownStyles$exten7 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten7 === void 0 ? void 0 : _dropDownStyles$exten7.productNameColor,
          crossedOutPriceFont: (_dropDownStyles$exten8 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten8 === void 0 ? void 0 : _dropDownStyles$exten8.crossedOutPriceFont
        } : undefined,
        isOrderView: false
      }));
    }), results.length > 0 && __jsx(Link, {
      route: "catalogsearch",
      params: {
        query: phrase
      }
    }, __jsx(_LinkRaw["default"], {
      sx: {
        color: (_dropDownStyles$exten9 = (_dropDownStyles$exten0 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten0 === void 0 ? void 0 : _dropDownStyles$exten0.categoryColor) !== null && _dropDownStyles$exten9 !== void 0 ? _dropDownStyles$exten9 : "main",
        font: (_dropDownStyles$exten1 = (_dropDownStyles$exten10 = dropDownStyles.extendedStyles) === null || _dropDownStyles$exten10 === void 0 ? void 0 : _dropDownStyles$exten10.productNameFont) !== null && _dropDownStyles$exten1 !== void 0 ? _dropDownStyles$exten1 : "s_sans_bold",
        pt: "s6",
        display: "flex",
        alignItems: "center",
        svg: {
          ml: "s6",
          mt: -3,
          pointerEvents: "none"
        }
      },
      title: translations.seeAllSuggestions
    }, translations.seeAllSuggestions, !dropDownStyles.customColumns && __jsx(ArrowRightIcon, null)))), !dropDownStyles.customColumns && __jsx(_Box["default"], {
      sx: {
        width: "277px",
        ml: "s8"
      }
    }, (results === null || results === void 0 ? void 0 : results.length) > 3 && results.slice(3, 6).map(function (item) {
      return __jsx(_Box["default"], {
        sx: {
          height: "80px",
          mb: "s8"
        }
      }, __jsx(_ProductRow["default"], {
        sx: {
          height: "80px",
          mb: "s8"
        },
        product: item,
        quantity: 1,
        isQuantityPickerEnabled: false
      }));
    }))));
  }));
};
var _default = SearchDesktop;
exports["default"] = _default;